import "vite/modulepreload-polyfill";

import { setVh, setSvh } from "@js/css-vars.js";
setVh();
setSvh();

import { initializeApp } from "@js/vue/app.js";
initializeApp();

import createUnitlessVariable from "@js/unitless-css-vars.js";
createUnitlessVariable('--grid-size', '--grid-size-unitless');

import handleFixedSections, { calculateEarthTextOpacity } from "@js/sections.js";
handleFixedSections();
calculateEarthTextOpacity();

import { generateGraphicGrid, generateGridHashMarks, alignHeightWithGrid } from "@js/grid.js";
generateGraphicGrid();
generateGridHashMarks();
alignHeightWithGrid();

import { setupParallaxElements, setupParallaxElementOverflow } from "@js/parallax.js";
setupParallaxElements();
setupParallaxElementOverflow(true);

import { onResize, onResizeWidth } from "@js/throttle.js"
onResize(() => {
	setVh();
	setSvh();
});
onResizeWidth(() => {
	calculateEarthTextOpacity();
	generateGraphicGrid();
	generateGridHashMarks();
	alignHeightWithGrid();
	setupParallaxElementOverflow();
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log("HMR")
	});
}
